import { useOrder } from '@/contexts/OrderContext'
import { Group } from './types'

export const GROUPS: Group[] = [
  {
    name: 'format',
    title: 'Format',
    commands: [
      {
        name: 'blockquote',
        label: "Tableau d'examens",
        iconName: 'Table',
        description: '',
        action: editor => {
          editor.setExamTablesEditor(editor)
        },
      },
      {
        name: 'bulletList',
        label: 'Liste à puces',
        iconName: 'List',
        description: 'Unordered list of items',
        aliases: ['ul'],
        action: editor => {
          editor.chain().focus().toggleBulletList().run()
        },
      },
      {
        name: 'numberedList',
        label: 'Liste numérotée',
        iconName: 'ListOrdered',
        description: 'Ordered list of items',
        aliases: ['ol'],
        action: editor => {
          editor.chain().focus().toggleOrderedList().run()
        },
      }
    ],
  }
]

export default GROUPS
